<div class="container flex flex-col">
    <div class="text-xl font-bold">Registracija novog korisnika</div>

    <div class="mb-2 w-full flex flex-col gap-2">
        <form [formGroup]="registerForm">
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email" />
            </mat-form-field>

            <mat-form-field>
                <mat-label>Ime i prezime</mat-label>
                <input matInput formControlName="name" />
            </mat-form-field>

            <mat-form-field>
                <mat-label>Broj telefona</mat-label>
                <input matInput formControlName="phone" />
            </mat-form-field>

            <div class="flex flex-row gap-4 justify-between items-center">
                <button
                    class="self-end"
                    mat-flat-button
                    color="primary"
                    (click)="onSubmit()"
                    [disabled]="!registerForm.valid"
                >
                    Registriraj me
                </button>
            </div>
        </form>
    </div>
</div>
